import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-add-folder',
  templateUrl: './add-folder.component.html',
  styleUrls: ['./add-folder.component.scss']
})
export class AddFolderComponent implements OnInit {
  folderForm!: FormGroup;
  loader: boolean = false;
  isTablet: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddFolderComponent>,
    private adminservice: AdminService,
    private router: Router
  ) { }

  ngOnInit() {
    this.formBuilder();
    if (this.data?.id > 0) {
      const data = {
        folderId: this.data.id,
        name: this.data.nombre
      }
      this.folderForm.patchValue(data);
    };
    this.isTablet = this.router.url.includes('pastillas') ? true : false;
  }

  formBuilder(){
    this.folderForm = new FormGroup({
      folderId: new FormControl(0),
      name: new FormControl('', Validators.required)
    });
  }

  saveDataFolder(){
    if (!this.folderForm.valid) {
      return
    }

    const request = {
      directorio_id: this.folderForm.value.folderId,
      nombre: this.folderForm.value.name
    }
    this.loader = true;
    
    if (this.isTablet) {
      this.adminservice.saveDataTablet(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.dialogRef.close(true)
          }
        }
      );
    }else{
      this.adminservice.saveDataFolder(request).subscribe(
        (response)=>{
          this.loader = false;
          if (response.rtn) {
            this.dialogRef.close(true)
          }
        }
      );
    }
  }

}
